import React, { useEffect, useMemo, useState } from 'react'
import { withTranslation } from 'react-i18next';

// Component
import { HeaderListComponent, LoadingComponent, PageListComponent, FormActionComponent, FormWrapperInputComponent } from '../../../../common/component/Index';
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import { Checkbox, Icon, Input, List, message, Radio, Table, Tooltip } from 'antd';
import TextArea from '../../../../common/component/TextArea';

// Func common
import * as Func from '../../../../../../helpers/functions';
import { PATHS, CASH_FLOW_REPORT } from '../../../../../../constants/Define';
import Wrapper from '../../../../common/component/Wrapper';
import { ReceiptsPayslip } from '../../../../../../models/CashFlow';
import {toArray} from 'lodash'

// Style
import './CashFlowDetail.less'

const listAnother = [
    { code: 7777, name: "Tạo phiếu chi" },
    { code: 8888, name: "Tạo phiếu thu" }
]

const CashFlowDetail = (props) => {

    const {
        CashFlowState,
        getTransactions,
        getAccounts,
        getTransactionsImbalance,
        createReceiptPayslipDetail,
        t,
    } = props

    const [receiptsPayslip, setReceiptsPayslip] = useState(new ReceiptsPayslip())
    const [validation, setValidation] = useState({})
    const [orderCodes, setOrderCodes] = useState([])
    const [isPreview, setIsPreview] = useState(false)
    const [cashFlowPreview, setCashFlowPreview] = useState([])

    useEffect(() => {
        getTransactions();
        getTransactionsImbalance()
    }, [])

    useEffect(() => {
        onFilter()
    }, [receiptsPayslip.account])

    useEffect(() => {
        
        const totalAmount = orderCodes.reduce((prevValue, currValue) => prevValue + currValue.amount, 0)
        setReceiptsPayslip({
            ...receiptsPayslip,
            totalAmount
        })
    }, [orderCodes])

    const onFilter = () => {
        getTransactionsImbalance({
            transactionCode: receiptsPayslip.transactionCode,
            account: receiptsPayslip.account,
            orderCodes: receiptsPayslip.orderCode
        })
    }

    const onClickBack = () => {
        if(isPreview) {
            setCashFlowPreview([])
            setIsPreview(false)
        } else {
            props.history.push(PATHS.REPORT.CASH_FLOW_REPORT.path);
        }
       
    }

    const onChangeTransaction = (transaction) => {
        const listTransaction = Object.entries(CASH_FLOW_REPORT.TRANSACTION_CODE_TYPE);
        const dataTransactionCode = receiptsPayslip.type === 1 ? listTransaction : listAnother
        const dataTransactionSelect = dataTransactionCode.find(item => receiptsPayslip.type === 1 ? item[0] === transaction : item.code === transaction)
        setReceiptsPayslip({
            ...receiptsPayslip,
            transactionCode: receiptsPayslip.type === 1 ? dataTransactionSelect[0] : dataTransactionSelect.code,
            transactionName: receiptsPayslip.type === 1 ? dataTransactionSelect[1] : dataTransactionSelect.name,
            account: undefined
        })
        
        if(receiptsPayslip.type === 1) {
            getTransactionsImbalance({
                transactionCode: dataTransactionSelect[0],
                account: undefined,
                orderCodes: receiptsPayslip.orderCode
            })
            getAccounts({ transactionCode: dataTransactionSelect[0] })
        }

        clearSelectOrderCode()
    }

    const onChangeFilter = (key, value) => {
        setReceiptsPayslip({
            ...receiptsPayslip,
            [key]: value.trimLeft()
        })

        clearSelectOrderCode()
    }

    const onChangeOrderCode = (transactionImbalance, checked) => {
        const arrCodes = [...orderCodes]
        if(!checked) {
            const unCheckedIndex = arrCodes.findIndex(item => item.orderCode === transactionImbalance.orderCode)
            arrCodes.splice(unCheckedIndex, 1)
            return setOrderCodes(arrCodes)
        }
        arrCodes.push({
            ...transactionImbalance,
            type: receiptsPayslip.transactionName
        })

        setOrderCodes(arrCodes)
    }

    const onChangeInput = (key, value) => {
        setReceiptsPayslip({
            ...receiptsPayslip,
            [key]: value
        })
    }

    const clearSelectOrderCode = () => {
        setOrderCodes([])
    }

    const onChangeType = (e) => {
        setReceiptsPayslip({
            ...new ReceiptsPayslip(),
            type: e.target.value
        })

        if(e.target.value === 1) {
            getTransactionsImbalance()
        }

        setOrderCodes([])
        setCashFlowPreview([])
        setIsPreview(false)
    }

    const onSubmit = (e) => {
        e.preventDefault()
        if(validate()) {
            if(receiptsPayslip.type === 1 && orderCodes.length === 0) {
                return message.error('Vui lòng chọn giao dịch!')
            }
            if(isPreview === false) {
                handlePreviewData()
                
            } else {
                const codes = orderCodes.reduce((prevValue, currValue) => [...prevValue, currValue.orderCode], [])
                const dataSubmit = new ReceiptsPayslip({
                    ...receiptsPayslip,
                    orderCodes: codes
                })
                createReceiptPayslipDetail(dataSubmit)
            }
        }
        
    }

    const handlePreviewData = () => {
        const totalAmount = !!receiptsPayslip.totalAmount ? parseInt(receiptsPayslip.totalAmount) : 0
        if(receiptsPayslip.type === 1) {
            const totalAmountTransaction = orderCodes.reduce((prevValue, currValue) => prevValue + currValue.amount, 0)
            const receiptsPayslipTotalAmount = parseInt(receiptsPayslip.totalAmount)
            const overLeftMoney = totalAmount - totalAmountTransaction
            setCashFlowPreview([
                {
                    orderCode: ' ',
                    amount: totalAmount,
                    type: 'Cân đối dòng tiền'
                },
                ...orderCodes
                // ,
                // {
                //     orderCode: '  ',
                //     amount: overLeftMoney,
                //     type: 'Tiền dư'
                // }
            ])
        } else {
            if(receiptsPayslip.transactionCode === 8888 && totalAmount <= 0) {
                return message.error('Nhập tổng tiền phải lớn hơn 0')
            }
            if(receiptsPayslip.transactionCode === 7777 && totalAmount >= 0) {
                return message.error('Nhập tổng tiền phải nhỏ hơn 0')
            }
            const dataTotalAmount = [
                {
                    orderCode: receiptsPayslip.orderCode,
                    amount: totalAmount,
                    type: receiptsPayslip.transactionName
                }
            ]
            setCashFlowPreview(dataTotalAmount)
            setOrderCodes(dataTotalAmount)
        }

        setIsPreview(true)
    }

    const validate = () => {
        let validate = {
            required: {
                transactionCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.cashFlow.transactionCode`)),
                ftCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.cashFlow.ftCode`)),
                totalAmount: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.cashFlow.totalAmount`)),
            }
        };

        let valueValidate = {};

        if(receiptsPayslip.type === 1) {
            validate.required.account = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.cashFlow.account`))
        }

        if(receiptsPayslip.type === 2) {
            validate.required.orderCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.cashFlow.orderCode`))
        }
        const result = Func.multipleValidate(receiptsPayslip, validate, valueValidate);
        setValidation(result);
        return Object.keys(result).length < 1;
    }

    const onEnterInput = (e) => {
        e.preventDefault()
        if(receiptsPayslip.type === 1) {
            onFilter()
        }
    }

    const selectFilterSearch = () => {

    }

    const onCheckedAll = (checked) => {
        let arrCodes = []
        if(!checked) {
            return setOrderCodes([])
        }

        CashFlowState.allData.transactionImbalances.forEach(item => {
            arrCodes.push({
                ...item,
                type: receiptsPayslip.transactionName
            })
        })

        setOrderCodes(arrCodes)
    }
    
    const columns = useMemo(() => {
        return  [
            {
              title: t(`item.cashFlow.amount`),
              dataIndex: 'amount',
              key: 'amount',
              render: (value, record) => Func.formatMoney(Func.checkUndefine(value))
            },
            {
              title: t(`item.cashFlow.orderCode`),
              dataIndex: 'orderCode',
              key: 'orderCode',
            },
            {
              title: t(`item.cashFlow.transactionName`),
              dataIndex: 'type',
              key: 'type',
            },
          ];
    }, [])

    const isCheckedAll = orderCodes.length === CashFlowState.allData.transactionImbalances.length

    return (
        <LoadingComponent spinning={CashFlowState.isFetching}>
            <PageListComponent className="cash-flow-detail-page">
                <HeaderListComponent
                    path={props.match.path}
                    groupPath={'cashFlow'}
                    titleHeader={Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.receiptsPayslip.title')}`).toLowerCase())}
                />
                <FormActionComponent
                    onSubmit={onSubmit}
                    isSubmit={CashFlowState.isFetching}
                    action={'confirm'}
                    onClickBack={onClickBack}
                    isDisableAction={receiptsPayslip.transactionCode === 1100}
                    backButtonText={isPreview ? t(`action.cancel`) : t(`action.back`)}
                    titleButtonSubmit={isPreview ? t(`action.confirm`) : t(`action.create`)}
                    submitButtonRight={true}
                >
                    <Wrapper className="col-md-6 m-b cash-flow-form" style={{ background: '#fff', padding: '15px 25px'}}>
                        { isPreview && <div className="disabled-layout"></div>}
                        <Wrapper className="row">
                            <Wrapper className="col-md-12 m-b basic-section">
                                <Radio.Group defaultValue={1} buttonStyle="solid" onChange={onChangeType}>
                                    <Radio.Button value={1}>Phải thu / phải chi</Radio.Button>
                                    <Radio.Button value={2}>Thu / chi phát sinh</Radio.Button>
                                </Radio.Group>
                            </Wrapper>
                            <Wrapper className='col-md-4 basic-section'>
                                <FormWrapperInputComponent
                                    isRequired={true}
                                    isValidation={true}
                                    dataValidation={receiptsPayslip.transactionCode}
                                    validation={validation.transactionCode}
                                    labelTitle={t(`item.cashFlow.transactionCode`)}
                                >
                                    <AntSelect className="select-transactionCode"
                                        showArrow showSearch
                                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.cashFlow.transactionCode")).toLowerCase())}
                                        value={receiptsPayslip.transactionCode}
                                        onChange={(value) => onChangeTransaction(value)}
                                        style={{ width: '100%' }}
                                        filterOption={selectFilterSearch}
                                    >
                                        {
                                            receiptsPayslip.type === 1 ? 
                                            Object.entries(CASH_FLOW_REPORT.TRANSACTION_CODE_TYPE).map(transaction => (
                                                <AntOption key={transaction[0]} value={transaction[0]}>{transaction[0]} | {transaction[1]}</AntOption>
                                            ))
                                            : listAnother.map(transaction => (
                                                <AntOption key={transaction.code} value={transaction.code}>{transaction.code} | {transaction.name}</AntOption>
                                            ))
                                        }
                                    </AntSelect>
                                </FormWrapperInputComponent>
                            </Wrapper>
                            {
                                receiptsPayslip.type === 1 && 
                                <Wrapper className='col-md-4 basic-section'>
                                    <FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={receiptsPayslip.account}
                                        validation={validation.account}
                                        labelTitle={t(`item.cashFlow.account`)}
                                    >
                                        <AntSelect className="select-account"
                                            showArrow showSearch
                                            placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.cashFlow.account")).toLowerCase())}
                                            value={receiptsPayslip.account}
                                            onChange={(value) => onChangeFilter('account', value)}
                                            style={{ width: '100%' }}
                                            filterOption={selectFilterSearch}
                                        >
                                            {CashFlowState.allData.accounts.map(account => (
                                                <AntOption key={account.code} value={account.code}>{account.code}</AntOption>
                                            ))}
                                        </AntSelect>
                                    </FormWrapperInputComponent>
                                </Wrapper>
                            }
                            <Wrapper className='col-md-4 basic-section'>
                                <FormWrapperInputComponent
                                    isRequired={receiptsPayslip.type === 2}
                                    isValidation={receiptsPayslip.type === 2}
                                    dataValidation={receiptsPayslip.orderCode}
                                    validation={validation.orderCode}
                                    labelTitle={ receiptsPayslip.type === 1 ? t(`item.cashFlow.searchOrderCode`) : t(`item.cashFlow.orderCode`) }
                                >
                                    <div
                                        className="input-view-order"
                                    >
                                        <Input placeholder="" type={`text`}
                                            suffix={ receiptsPayslip.type === 1 ? <Icon type="search"  /> : null }
                                            className={`form-control`}
                                            name={`orderCode`}
                                            onChange={(e) => onChangeFilter('orderCode', e.target.value)}
                                            onPressEnter={onEnterInput}
                                            value={Func.checkUndefine(receiptsPayslip.orderCode)} />
                                        { 
                                            receiptsPayslip.orderCode && 
                                            <Tooltip title={t(`item.cashFlow.titleViewPopup`)}>
                                                <a 
                                                    key="list-loadmore-more" 
                                                    href={Func.getPathWithParams(PATHS.REPORT.CASH_FLOW_REPORT.pathFiltered, { orderCode: receiptsPayslip.orderCode })} 
                                                    target="_blank"
                                                    className="m-l"
                                                >
                                                        <Icon type="eye" />
                                                </a>
                                            </Tooltip>
                                        }
                                    </div>
                                </FormWrapperInputComponent>
                            </Wrapper>
                            {
                                receiptsPayslip.type === 1 && 
                                <Wrapper className='col-md-12 basic-section'>
                                    <div>
                                        <Checkbox className="m-b"
                                            disabled={!receiptsPayslip.transactionCode || !receiptsPayslip.account}
                                            checked={isCheckedAll}
                                            onChange={e => onCheckedAll(e.target.checked)}
                                        >
                                            Chọn tất cả
                                        </Checkbox>
                                    </div>
                                    <List size="small"
                                        bordered
                                        className="list-order-code m-b"
                                        dataSource={CashFlowState.allData.transactionImbalances}
                                        renderItem={item =>
                                            <List.Item
                                                actions={[
                                                    <Tooltip title={t(`item.cashFlow.titleViewPopup`)}>
                                                        <a 
                                                            key="list-loadmore-more" 
                                                            href={Func.getPathWithParams(PATHS.REPORT.CASH_FLOW_REPORT.pathFiltered, { orderCode: item?.orderCode })} 
                                                            target="_blank"
                                                        >
                                                                <Icon type="eye" />
                                                        </a>
                                                    </Tooltip>
                                                ]}    
                                            >
                                                { !!receiptsPayslip.transactionCode && !!receiptsPayslip.account ? 
                                                    <Checkbox className="ml-2"
                                                        disabled={false}
                                                        checked={!!(orderCodes.find(order => order.orderCode === item?.orderCode))}
                                                        onChange={e => onChangeOrderCode(item, e.target.checked)}
                                                    >
                                                        {`${item?.orderCode} | ${item?.amount?.toLocaleString()} ${t(`currency`)}`}
                                                    </Checkbox>
                                                    : 
                                                    `${item?.orderCode} | ${item?.amount?.toLocaleString()} ${t(`currency`)}`
                                                }   
                                            </List.Item>
                                        }
                                    />
                                </Wrapper>
                            }
                            <Wrapper className="col-md-12 basic-section">
                                <FormWrapperInputComponent
                                    labelTitle={t(`item.cashFlow.note`)}
                                >
                                    <TextArea
                                        className="form-control" 
                                        name="note" 
                                        rows={3}
                                        onChange={(e) => onChangeInput('note', e.target.value)}
                                        value={Func.checkUndefine(receiptsPayslip.note)} />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className='col-md-5 basic-section'>
                                <FormWrapperInputComponent
                                    isRequired={true}
                                    isValidation={true}
                                    dataValidation={receiptsPayslip.totalAmount}
                                    validation={validation.totalAmount}
                                    labelTitle={t(`item.cashFlow.totalAmount`)}
                                >
                                    <Input placeholder="" type={`text`}
                                        disabled={receiptsPayslip.type === 1}
                                        className={`form-control`}
                                        name={`totalAmount`}
                                        onChange={(e) => onChangeInput('totalAmount', e.target.value)}
                                        value={Func.checkUndefine(receiptsPayslip.totalAmount)}
                                    />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className='col-md-7 basic-section'>
                                <FormWrapperInputComponent
                                    isRequired={true}
                                    isValidation={true}
                                    dataValidation={receiptsPayslip.ftCode}
                                    validation={validation.ftCode}
                                    labelTitle={t(`item.cashFlow.ftCode`)}
                                >
                                    <Input placeholder="" type={`text`}
                                        className={`form-control`}
                                        name={`ftCode`}
                                        onChange={(e) => onChangeInput('ftCode', e.target.value)}
                                        value={Func.checkUndefine(receiptsPayslip.ftCode)} />
                                </FormWrapperInputComponent>
                            </Wrapper>
                        </Wrapper>
                    </Wrapper>
                    {
                        isPreview &&
                        <Wrapper className="col-md-6 m-b" style={{ background: '#fff', padding: '15px 25px'}}>
                            <h4 className="m-b">Lưu ý!</h4>
                            <p className="m-b">Khi tạo một dòng tiền chỉ định cho đơn hàng, hệ thống sẽ tự động tách dòng tiền thành các giá trị phù hợp với mỗi đơn hàng lựa chọn</p>
                            <p>Danh sách dòng tiền sẽ phát sinh sau hành động.</p>
                            <Table 
                                dataSource={cashFlowPreview} 
                                rowKey={record => record.orderCode}
                                columns={columns} 
                            />
                        </Wrapper>
                    }
                </FormActionComponent>
            </PageListComponent>
        </LoadingComponent>
    )
}

export default withTranslation()(CashFlowDetail)

